import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-offcanvas-pagination-title',
  standalone: true,
  templateUrl: 'offcanvas-pagination-title.component.html',
  styleUrl: 'offcanvas-pagination-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OffcanvasPaginationTitleComponent {
  title = input<string | null>(null);
  currentIndex = input<number>(0);
  total = input<number>(0);
  isControlsDisabled = input<boolean>(false);

  moveToPrevious = output<void>();
  moveToNext = output<void>();
}
